import React, { ReactElement } from 'react';

export enum HeadCellFilterType {
  SORT = 'sort',
  CHECKBOXFILTER = 'checkboxFilter',
  SEARCHFILTER = 'search',
  EMPTY = '',
}

export type ColumnDefinition<T> = {
  id: keyof T;
  label: string | ReactElement;
  filter: HeadCellFilterType;
  filterInputPlaceholder?: string;
  filterInputType?: 'number' | 'text';
  filterValues?: (string | undefined)[];
  width: string;
  render?: (row: T, index?: number) => false | undefined | React.JSX.Element | React.JSX.Element[] | string | null;
  color?: string;
  shouldFormatEnum?: boolean;
};

export type DataTableWithId = {
  id: string;
};
